import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { FashionEditorTab } from './tabs/FashionEditorTab'
import { AIStudioGallery } from './gallery'
import { StyleRoomMigrationModal } from './components/StyleRoomMigrationModal'

const AIStudio: React.FC = () => {
  return (
    <div className="flex min-h-screen justify-center">
      <div className="flex w-full justify-center">
        <Routes>
          <Route index element={<FashionEditorTab />} />
          <Route path="gallery" element={<AIStudioGallery />} />
        </Routes>
      </div>

      {/* 스타일룸 이사 안내 모달 */}
      {/* <StyleRoomMigrationModal isOpen={true} /> */}
    </div>
  )
}

export default AIStudio
